export const Structure = [
	{
		name: "Accueil",
		path: "/"
	},
	{
		name: "À Propos",
		path: "/about"
	},
	{
		name: "Projets",
		path: "/projets"
	},
	{
		name: "Portfolio",
		path: "/portfolio"
	},
	{
		name: "Pages",
		path: "#",
		child: [
			{
				name: "Veilles",
				path: "/veille"
			},
			{
				name: "Stages",
				path: "/stage"
			},
			{
				name: "Projet Personnel Encadré",
				path: "/ppe"
			},
			{
				name: "Projet Personnel",
				path: "/pp"
			},
			{
				name: "Articles",
				path: "/article"
			},
			{
				name: "Contact",
				path: "/contact"
			}
		]
	}
];